export default {
  SET_INVENTORIES: function (state, data) {
    state.inventories = data;
  },
  SET_INVENTORIES_DEALER: function (state, data) {
    state.inventoriesDealer = data;
  }
}
